import { ICopyable } from '../core/copyable.interface';
import { IBoxGroup } from '../interfaces/box-group.interface';
import { Box } from './box';

export class BoxGroup implements ICopyable<BoxGroup> {
    id: string = null;
    name: string = null;
    order: number = null;
    boxes: Box[] = null;

    public createCopy(): BoxGroup {
        const instance = new BoxGroup();
        instance.id = this.id;
        instance.name = this.name;
        instance.order = this.order;
        instance.boxes = Box.fromArray(this.boxes);

        return instance;
    }

    public static createFormCopy(box: BoxGroup): IBoxGroup {
        const instance = new BoxGroup();
        instance.id = box.id;
        instance.name = box.name;
        instance.order = box.order;
        instance.boxes = Box.fromArray(box.boxes);

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.order = other.order;
        this.boxes = Box.fromArray(other.boxes);
    }
}
